// =============================================================================
// SIREPPAR - Pestañas "Consultas de partidos | Interacciones"
// =============================================================================
// Las dos bandejas comparten un solo ítem de menú y se alternan con estas
// pestañas. Es SOLO la vista: cada pestaña sigue siendo su propia pantalla, con
// su URL de siempre (/interacciones y /gestion-consultas), así que los enlaces
// que ya existen —alertas, "Volver a la bandeja"— no cambian.
//
// Con VITE_CONSULTAS_HABILITADAS en false (producción) no hay segunda pestaña:
// el componente no muestra nada y el menú lleva directo a Interacciones.
// =============================================================================

import { Link, useLocation } from 'react-router-dom';
import { CONSULTAS_HABILITADAS } from '../../utils/consultas';
import { useConsultasPendientes } from '../../hooks/useConsultasPendientes';

// Consultas primero: es la bandeja a la que lleva el ítem del menú.
const PESTANIAS = [
  { href: '/gestion-consultas', etiqueta: 'Consultas de partidos' },
  { href: '/interacciones', etiqueta: 'Interacciones' },
] as const;

export default function PestaniasComunicaciones() {
  const location = useLocation();
  // Mismo contador que el menú: comparten la clave de react-query, no hay un
  // pedido extra.
  const pendientes = useConsultasPendientes(CONSULTAS_HABILITADAS);

  if (!CONSULTAS_HABILITADAS) return null;

  return (
    <div className="border-b border-gray-200 mb-6">
      <nav className="-mb-px flex space-x-8">
        {PESTANIAS.map((p) => {
          const activa = location.pathname === p.href || location.pathname.startsWith(p.href + '/');
          return (
            <Link
              key={p.href}
              to={p.href}
              aria-current={activa ? 'page' : undefined}
              className={`py-2 px-1 border-b-2 font-medium text-sm flex items-center gap-2 ${
                activa
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              {p.etiqueta}
              {p.href === '/gestion-consultas' && pendientes > 0 && (
                <span
                  className="text-xs bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded"
                  title="Consultas que esperan respuesta de la SEP"
                >
                  {pendientes}
                </span>
              )}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
